module.exports = __webpack_public_path__ + "static/todoist_5-81ee1c3ca334effef8f29836c252926b.png";